import React from 'react';
import { useQuery } from "@/lib/crud/useQuery";
import { gql } from "@/lib/generated/gql-codegen";
import Loading from "../vulcan-core/Loading";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const TagRelFragmentQuery = gql(`
  query TagRelNotificationItem($documentId: String) {
    tagRel(input: { selector: { documentId: $documentId } }) {
      result {
        ...TagRelFragment
      }
    }
  }
`);

const styles = defineStyles('TagRelNotificationItem', (theme: ThemeType) => ({
  meta: {
    fontSize: ".9rem",
    color: theme.palette.text.dim45,
  },
  title: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
}));

export const TagRelNotificationItem = ({tagRelId}: {
  tagRelId: string
}) => {
  const classes = useStyles(styles);
  const { loading, data } = useQuery(TagRelFragmentQuery, {
    variables: { documentId: tagRelId },
  });
  const tagRel = data?.tagRel?.result;

  if (loading) return <Loading/>
  if (!tagRel) {return null;}

  return <div>
    <div className={classes.meta}>New post tagged <em>{tagRel.tag?.name}</em>:</div>
    <div className={classes.title}>{tagRel.post?.title}</div>
  </div>;
}

export default TagRelNotificationItem



